module.exports = __webpack_public_path__ + "img/img (50).6794fe09.png";